@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/colors';

.table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  .headerRow {
    position: sticky;
    top: 0;
    background: var(--light-100);
    z-index: 1;
  }

  .th {
    text-align: left;
    padding: 8.5px 8px;
  }

  .tr {
    cursor: pointer;

    &:hover:not(.selected) {
      background: var(--dark-2);
    }

    &.selected {
      background: var(--dark-2);
    }
  }

  .td {
    position: relative;
    padding: 8.5px 8px;
    vertical-align: middle;

    &:first-child {
      border-radius: 7px 0 0 7px;
      padding-right: 4px;
      width: 40px;
    }

    &:last-child {
      border-radius: 0 7px 7px 0;
    }
  }

  .column {
    &:first-child {
      width: 95px;
    }

    &:nth-child(2) {
      width: auto;
    }

    &:nth-child(3) {
      width: 190px;
    }

    &:last-child {
      width: 190px;
    }
  }

  .statusCell {
    white-space: nowrap;
  }
}

.coverImage {
  position: relative;
  width: 75px;
  height: 75px;
}

.coverEmpty {
  width: 75px;
  height: 75px;
  border-radius: 8px;
  background: var(--dark-4);
}

.campaignStrategy {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 3px;
  flex: 1 0 0;
  min-width: 0;
  align-self: stretch;
}

.skeletonThumbnail {
  width: 75px;
  height: 75px;
  border-radius: 8px;
}
